/**
 * Activity log hooks using TanStack Query (Admin only)
 */

import { useQuery } from '@tanstack/react-query'
import { activityService } from '@/api'
import type { ActivityLogFilterParams, ActivityLogListResponse } from '@/types/api'

/**
 * Query keys for activity logs
 */
export const activityKeys = {
  all: ['activity'] as const,
  lists: () => [...activityKeys.all, 'list'] as const,
  list: (params: ActivityLogFilterParams) => [...activityKeys.lists(), params] as const,
}

/**
 * Hook to get activity logs
 */
export function useActivityLogs(params?: ActivityLogFilterParams) {
  return useQuery<ActivityLogListResponse>({
    queryKey: activityKeys.list(params || {}),
    queryFn: () => activityService.getActivityLogs(params),
  })
}
